import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Company, User } from './types';
import isEqual from 'react-fast-compare';
import * as AuthService from '../../libs/auth';
import { useLocation, useParams } from 'react-router';
import ngDeps from '../../libs/ngDeps';
import { useChannel, useClientTrigger, useEvent } from '@harelpls/use-pusher';
import useInterval from '../../hooks/useInterval';

type Auth = {
  currentUser: User | null;
  isAuthenticated: boolean;
  isBookkeeper: boolean;
  isAdmin: boolean;
  logout: () => void;
};

export const AuthContext = React.createContext<Auth>({
  currentUser: null,
  isAuthenticated: false,
  isBookkeeper: false,
  isAdmin: false,
  logout: () => AuthService.logout,
  accessToken: null,
});

export const AuthProvider: React.FC = ({ children }) => {
  const [currentUser, setCurrentUser] = useState<User | null>(AuthService.getCurrentUser());
  const [accessToken, setAccessToken] = useState<string | null>(AuthService.getAccessToken());
  const params = useParams();
  const isAuthenticated = !!currentUser;
  const isBookkeeper = currentUser?.isBookkeeper || false;
  const isAdmin = currentUser?.isAdmin || false;
  const logout = useCallback(AuthService.logout,[]);
  const location = useLocation()
  // console.log('location',location);
  const { $location, $timeout } = ngDeps as any;

  // TODO only for bookkeepers?
  // const channel = useChannel("presence-channel");
  // useEvent(channel, "pusher:member_added", (member : any) => {
  //   }
  // );
  // useEvent(channel, "pusher:member_removed", (member : any) => {
  // });

  //
  // const trigger = useClientTrigger(channel);
  // useInterval(() => {
  //   // Your custom logic here
  //   trigger("client-current-company-request", {message: 'hello'});
  // }, 2000);

  useEffect(() => {
    const handleStorageChange = ({key, oldValue, newValue}: StorageEvent) => {
      if(key === '$LoopBack$currentUserId' && !isEqual(oldValue, newValue)) {
        setCurrentUser(AuthService.getCurrentUser())
      }
      if(key === '$LoopBack$accessTokenId' && !isEqual(oldValue, newValue)) {
        setAccessToken(AuthService.getAccessToken())
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  useEffect(() => {
    console.log('location.pathname',location.pathname);
    $timeout(() => {

      // $location.path(location.pathname).search(location.search);
      const popStateEvent = new PopStateEvent('popstate');
      dispatchEvent(popStateEvent);
    },0);

  }, [location.pathname]);

  const authValue = useMemo(() => {
    return { currentUser, isAuthenticated, isBookkeeper, isAdmin, logout, accessToken };
  }, [currentUser?.id, isAuthenticated, isBookkeeper, isAdmin]);

  return (
    <AuthContext.Provider
      value={authValue}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const IsBookkeeper: React.FC = ({ children }) => {
  const [currentUser, setCurrentUser] = useState<User | null>(AuthService.getCurrentUser());
  const isBookkeeper = currentUser?.isBookkeeper || false;

  if(isBookkeeper) {
    return <>{children}</>
  }

  return null;
}


export const useAuth = () => React.useContext(AuthContext);
